module.exports = __webpack_public_path__ + "static/media/boy.88f0482e.svg";